module.exports = __webpack_public_path__ + "static/media/logo.07b8560a.png";